export const LiveAgentInteractionTypes = {
  Task: "Task",
  Team: "Team"
}

export const LiveAgentEntryLocalStorageKeys = {
  Task: `LiveAgentEntryId_${LiveAgentInteractionTypes.Task}`,
  Team: `LiveAgentEntryId_${LiveAgentInteractionTypes.Team}`,
}
